import { render, staticRenderFns } from "./FormContactCards.vue?vue&type=template&id=0d1b6bed&scoped=true"
import script from "./FormContactCards.vue?vue&type=script&lang=js"
export * from "./FormContactCards.vue?vue&type=script&lang=js"
import style0 from "./FormContactCards.vue?vue&type=style&index=0&id=0d1b6bed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1b6bed",
  null
  
)

export default component.exports